<template>
  <div>
        <div class="update_wrap">
            <span class="text_span">刷新时间: {{lodeTime}}</span>
            <img src="../../assets/img/update_btn.png" @click="refresh" alt="">
        </div>
        <div style="height:350px;overflow-y:scroll">
            <table class="ivu-table table m-t-10" cellspacing="0" cellpadding="0">
            <tr  class="ivu-table-cell">
                <th>测点名称</th>
                <th>当前状态</th>
            </tr>
            <tr v-for="(tab,$index) in list" :key="$index" class="textC">
                <td>
                 <span class="ivu-table-cell">{{tab.pointName}}<i v-show="tab.unit">({{tab.unit}})</i></span>
                </td>
                 <td> 
                    <span v-if="Number(tab.value)==1" class="switch">ON</span>
                    <span v-else-if="Number(tab.value)==0" class="switch"  style="background:#ccc">OFF</span>
                    <span v-else>~</span></td>
            </tr>
        </table>
        </div>
        
       
    </div>
</template>
<script>
import lineChart from '@/components/line.vue';
import { getDate } from '@/assets/js/index.js';
export default {
  name:"",    
  data: () => ({
    lineData: {
        x: [],
        y: [],
    },
    loadValue: {},
    lodeTime: '',
    list: [],
  }),
  props: ['partId'],
  components: {
    lineChart
  },
  created() {

  },
  mounted() {
    this.getData();
  },
  computed: {

  },
  methods: {
    getData(){
        this.refresh();
        this.getTable();
    },
    refresh() {
        this.lodeTime = getDate(new Date().getTime(), 'year');
        this.getTable();
    },

    getTable() {
        this.lineData =  {
            x: [],
            y: [],
        };
        this.loadValue = {};
        this.list = [];

        return new Promise((resolve, reject) => {
            let url = `/mcbw/network_monitor/pointNowValue/${this.partId}`;
            let _this = this;
            var data = {
                type: 'get',
                url: url,
                obj: {
                    orgId: this.$store.state.baseInfoLayer.baseInfoId,
                    type: 'zt',
                }
            };
            _this.$Axios(data).then((res) => {
                if (res) {
                    let datas=res.data.data;
                    let lists=[];
                    datas.forEach((tab,index)=>{
                         if(tab.type!=='20409'&&tab.type!=='20412'&&tab.type!=='20417'){
                            lists.push(tab)
                         }
                    })
                    this.list = lists;
                }
                resolve()
            }).catch(err => {
                reject(err)
            })
        })
    },
  }
}
</script>
<style lang="scss" scoped>
/deep/ .ivu-table th,
/deep/ .ivu-table td{
    text-align: center;
} 
.text_span{
    color: #515a6e;
}
table{
    width: 100%
}
.update_wrap{
    display: flex;
    justify-content: flex-end;
    .update_info{
        display: flex;
        align-items: center;
        justify-content: space-between;
        span{
            margin-right: 10px;
        }
        img{
            width: 16px;
            height: 16px;
            cursor: pointer;
        }
    }
}
.ivu-table{
    tr{
        background-color: #515a6e
    }
}
.switch{
    display:inline-block;
    width:38px;
    height:22px;
    line-height: 22px;
    border-radius: 4px;
    background: green;
    color:#fff;
    font-size:13px;
    text-align: center
}
</style>


// WEBPACK FOOTER //
// src/components/xfs/zt.vue